import React from "react";
import {
  ActivityIndicator,
  ColorValue,
  DimensionValue,
  Pressable,
  SafeAreaView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import {
  color_333333,
  color_F1F1F1,
  color_main,
  white,
} from "../assets/style/colors";
import { useAppNavigation } from "../screen/navigation";

type ScreenModalProps = {
  onClose?: () => void;
  children: React.ReactNode;
  maxWidth?: DimensionValue;
  maxHeight?: DimensionValue;
  minHeight?: DimensionValue;
  backgroundColor?: ColorValue;
  offSetx?: DimensionValue;
  forbidMaskClose?: boolean; // 点击外部阴影是否消失
}
type ScreenCloseModalProps = { title?: string; } & ScreenModalProps

type ScreenLeftCloseModalProps = { rightChildren?: React.ReactNode; } & ScreenCloseModalProps

type ScreenCancelModalProps = {
  leftText?: string;
  rightText?: string;
  onLeftPress?: () => void;
  onRightPress?: () => void;
  rightDisabled?: boolean;
  rightLoading?: boolean;
} & ScreenCloseModalProps

export const ScreenCancelModal: React.FC<ScreenCancelModalProps> = (
  props: ScreenCancelModalProps
) => {
  const {
    title,
    leftText,
    rightText,
    onLeftPress,
    onRightPress,
    rightDisabled = false,
    rightLoading = false,
    children,
    maxWidth = 900,
    maxHeight = "90%",
    minHeight = 500,
    backgroundColor,
    offSetx,
    forbidMaskClose = false,
  } = props;
  const navigation = useAppNavigation();
  function onClose() {
    onLeftPress ? onLeftPress() : navigation.goBack();
  }
  return (
    <ScreenModal
      onClose={onClose}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
      minHeight={minHeight}
      backgroundColor={backgroundColor}
      offSetx={offSetx}
      forbidMaskClose={forbidMaskClose}
    >
      <View style={{ flex: 1 }}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            paddingVertical: 20,
            paddingHorizontal: 24,
            borderBottomWidth: 1,
            borderBottomColor: "#F0F0F0",
            backgroundColor: "#FAFAFA",
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
          }}
        >
          <TouchableOpacity
            activeOpacity={0.7}
            onPress={onClose}
            style={{ paddingHorizontal: 12, paddingVertical: 4 }}
          >
            <Text style={{ fontSize: 16, color: "#666", fontWeight: "400" }}>
              {leftText}
            </Text>
          </TouchableOpacity>
          <View
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {title && (
              <Text
                numberOfLines={1}
                style={{
                  fontSize: 18,
                  fontWeight: "600",
                  color: "#1A1A1A",
                  letterSpacing: 0.3,
                }}
                ellipsizeMode={"tail"}
              >
                {title}
              </Text>
            )}
          </View>
          <TouchableOpacity
            activeOpacity={0.8}
            onPress={onRightPress}
            disabled={rightDisabled || rightLoading}
            style={{
              backgroundColor: rightDisabled || rightLoading ? '#CCCCCC' : color_main,
              borderRadius: 8,
              minWidth: 70,
              paddingHorizontal: 20,
              height: 38,
              alignItems: "center",
              justifyContent: "center",
              shadowColor: color_main,
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.2,
              shadowRadius: 4,
              elevation: 3,
            }}
          >
            {rightLoading ? (
              <ActivityIndicator size="small" color={white} />
            ) : (
              <Text style={{ fontSize: 15, color: white, fontWeight: "600" }}>
                {rightText}
              </Text>
            )}
          </TouchableOpacity>
        </View>
        {children}
      </View>
    </ScreenModal>
  );
};
export const ScreenCloseModal: React.FC<ScreenCloseModalProps> = (
  props: ScreenCloseModalProps
) => {
  const {
    title,
    children,
    maxWidth = 900,
    maxHeight = "90%",
    minHeight = 500,
    backgroundColor,
    offSetx,
    forbidMaskClose = false,
  } = props;
  const navigation = useAppNavigation();
  function onClose() {
    props.onClose ? props.onClose() : navigation.goBack();
  }
  return (
    <ScreenModal
      onClose={onClose}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
      minHeight={minHeight}
      offSetx={offSetx}
      backgroundColor={backgroundColor}
      forbidMaskClose={forbidMaskClose}
    >
      <View style={{ flex: 1 }}>
        <View style={styles.headerContainer}>
          {/* 左侧占位，保持标题居中 */}
          <View style={styles.leftPlaceholder} />
          {/* 标题居中 */}
          <View style={styles.titleContainer}>
            <Text style={styles.title}>{title}</Text>
          </View>
          {/* 右侧关闭按钮 */}
          <Pressable onPress={onClose} style={styles.closeButton}>
            <Text style={styles.closeText}>×</Text>
          </Pressable>
        </View>
        {children}
      </View>
    </ScreenModal>
  );
};

export const ScreenLeftCloseModal: React.FC<ScreenLeftCloseModalProps> = (
  props: ScreenLeftCloseModalProps
) => {
  const {
    title,
    rightChildren,
    children,
    maxWidth = 900,
    maxHeight = "90%",
    minHeight = 500,
    backgroundColor,
    offSetx,
    forbidMaskClose = false,
  } = props;
  const navigation = useAppNavigation();
  function onClose() {
    props.onClose ? props.onClose() : navigation.goBack();
  }
  return (
    <ScreenModal
      onClose={onClose}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
      minHeight={minHeight}
      offSetx={offSetx}
      backgroundColor={backgroundColor}
      forbidMaskClose={forbidMaskClose}
    >
      <View style={{ flex: 1 }}>
        <View style={styles.headerContainer}>
          {/* 左侧占位，保持标题居中 */}

          <Pressable onPress={onClose} style={styles.closeButton}>
            <Text style={styles.closeText}>×</Text>
          </Pressable>
          {/* 标题居中 */}
          <View style={styles.titleContainer}>
            <Text style={styles.title}>{title}</Text>
          </View>
          {/* 右侧关闭按钮 */}
          {rightChildren ? rightChildren : <View style={styles.leftPlaceholder} />}
        </View>
        {children}
      </View>
    </ScreenModal>
  );
};
/**
 * 通用页面弹窗组件
 * 可以将任何页面内容以弹窗形式显示
 */
export const ScreenModal: React.FC<ScreenModalProps> = (
  props: ScreenModalProps
) => {
  const { maxWidth, maxHeight, minHeight, backgroundColor, children, offSetx, forbidMaskClose } =
    props;
  const navigation = useAppNavigation();
  function onClose() {
    props.onClose ? props.onClose() : navigation.goBack();
  }
  return (
    <TouchableOpacity
      style={[
        styles.backdrop,
        { backgroundColor: backgroundColor || "rgba(0,0,0,0.1)" },
      ]}
      activeOpacity={1}
      onPress={forbidMaskClose ? undefined : onClose}
    >
      <SafeAreaView
        style={[
          styles.container,
          {
            marginRight: offSetx || 0,
            maxWidth: maxWidth,
            maxHeight: maxHeight as any,
            minHeight: minHeight as any,
          },
        ]}
      >
        <TouchableOpacity
          activeOpacity={1}
          onPress={(e) => e.stopPropagation()}
          style={[styles.content]}
        >
          {children}
        </TouchableOpacity>
      </SafeAreaView>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    width: "90%",
    backgroundColor: white,
    borderRadius: 24,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 12,
    elevation: 8,
    overflow: "hidden", // 确保子元素遵循圆角
  },
  content: {
    flex: 1,
    borderRadius: 24, // 确保内容区域也有圆角
  },
  header: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: 16,
    paddingBottom: 8,
    minHeight: 56, // 与标题栏高度一致
  },
  closeButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    alignItems: "center",
    justifyContent: "center",
  },
  closeText: {
    fontSize: 24,
    color: color_333333,
    fontWeight: "300",
    lineHeight: 28,
  },
  leftPlaceholder: {
    width: 48, // 与关闭按钮宽度一致，保持标题居中
  },
  titleContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontSize: 18,
    fontWeight: "600",
    color: "#000000",
  },
  headerContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingVertical: 12,
    minHeight: 56,
    borderBottomWidth: 1,
    borderBottomColor: color_F1F1F1,
  },
});
